/// <reference path="WebService.ts" />

interface WebService
{    
    generateInvoice( business: BusinessLicense, chargeToDistributor: boolean, date:Date, serial:NumberSerialSequence, completion: any ) : void ;
    createTokensAndInstallments( business: BusinessLicense, date:Date, completion: any ) : void ;
    updateTokensPrice( business: BusinessLicense, date:Date, completion: any ) : void ;
    createInvoiceFromInstallment( installment: PaymentInstallment, completion: any ) : void ;
    updateInvoiceFromInstallment( installment: PaymentInstallment, completion: any ) : void ;
    createTokenFromLicense( license: License, date:Date, completion: any ) : void ;
    createTokensFromBusiness( business: BusinessLicense, date:Date, completion: any ) : void ;
    // updateBusinessInstallment( business: BusinessLicense, date:Date, completion: any ) : void ;    
    regenerateInvoice( invoiceNumber:string, business: BusinessLicense, tokenDate:Date, completion: any ) : void ;
    createReclaimInvoice( doc:Invoice, amount:number, completion:any ) : void ;
    sendLicenseInvoice( doc:Invoice, completion:any ) : void ;
    duplicateInstallment( installment:PaymentInstallment, date:Date, completion:any ) : void ;
    generateSEPAFileFromInstallments( installments:PaymentInstallment[], type:string, account:BankAccount, dueDate:string, filename:string, concept:string, completion:any ) : void;
}


WebService.prototype.generateInvoice = function( business: BusinessLicense, chargeToDistributor: boolean, date:Date, serial:NumberSerialSequence, completion: any ) : void
{
    let body = {}
    body["BusinessID"] = business.identifier;
    body["ChargeToDistributor"] = chargeToDistributor;
    body["Date"] = ( MUIWebApplication.sharedInstance().delegate as AppDelegate ).serverDateTimeFormatter.stringFromDate( date );
    //body["Date"] = (new MIOISO8601DateFormatter()).stringForObjectValue(date);
    
    if ( serial != null ) body["NumberSerialID"] = serial.identifier;

    const url = MIOURL.urlWithString(this.apiURL + "/entity/" + this.scheme + "/License/generate-invoice");
    let urlRequest = new MWSJSONRequest();
    urlRequest.initWithURL(url, body, "POST");
    urlRequest.execute(this, function(code:number, json:any) { 
        completion(json["data"], json["error"]);
    });

}

WebService.prototype.createTokensAndInstallments = function( business: BusinessLicense, date:Date, completion: any ) : void
{
    let d = (MUIWebApplication.sharedInstance().delegate as AppDelegate).serverDateFormatter.stringFromDate( date );

    let body = {}
    body["BusinessID"] = business.identifier;
    body["Date"] = d;

    const url = MIOURL.urlWithString(this.apiURL + "/entity/" + this.scheme + "/License/create-business-tokens-installments");
    let urlRequest = new MWSJSONRequest();
    urlRequest.initWithURL(url, body, "POST");
    urlRequest.execute(this, function(code:number, json:any) { 
        completion(json["data"], json["error"]);
    });
}

WebService.prototype.updateTokensPrice = function( business: BusinessLicense, date:Date, completion: any ) : void
{
    let d = (MUIWebApplication.sharedInstance().delegate as AppDelegate).serverDateFormatter.stringFromDate( date );

    let body = {}
    body["BusinessID"] = business.identifier;
    body["Date"] = d;

    const url = MIOURL.urlWithString(this.apiURL + "/entity/" + this.scheme + "/License/update-business-tokens-price");
    let urlRequest = new MWSJSONRequest();
    urlRequest.initWithURL(url, body, "POST");
    urlRequest.execute(this, function(code:number, json:any) { 
        completion(json["data"], json["error"]);
    });
}

WebService.prototype.createInvoiceFromInstallment = function( installment: PaymentInstallment, completion: any ) : void
{
    const url = MIOURL.urlWithString(this.apiURL + "/entity/" + this.scheme + "/License/create-invoice-from-installment/" + installment.identifier );
    let urlRequest = new MWSJSONRequest();
    urlRequest.initWithURL(url, null, "GET");
    urlRequest.execute(this, function(code:number, json:any) { 
        completion(json["data"], json["error"]);
    });
}

WebService.prototype.updateInvoiceFromInstallment = function( installment: PaymentInstallment, completion: any ) : void
{
    const url = MIOURL.urlWithString(this.apiURL + "/entity/" + this.scheme + "/License/update-invoice-from-installment/" + installment.identifier );
    let urlRequest = new MWSJSONRequest();
    urlRequest.initWithURL(url, null, "GET");
    urlRequest.execute(this, function(code:number, json:any) { 
        completion(json["data"], json["error"]);
    });
}


WebService.prototype.createTokenFromLicense = function ( license: License, date:Date, completion: any ) : void
{
    let d = (MUIWebApplication.sharedInstance().delegate as AppDelegate).serverDateFormatter.stringFromDate( date );
    
    const url = MIOURL.urlWithString( this.apiURL + "/entity/" + this.scheme + "/License/create-token-from-license/" + license.identifier + "/" + d );
    let urlRequest = new MWSJSONRequest();
    urlRequest.initWithURL(url, null, "GET");
    urlRequest.execute(this, function(code:number, json:any) { 
        completion(json["data"], json["error"]);
    });
}

WebService.prototype.createTokensFromBusiness = function ( business: BusinessLicense, date:Date, completion: any ) : void
{
    let d = (MUIWebApplication.sharedInstance().delegate as AppDelegate).serverDateFormatter.stringFromDate( date );
    
    const url = MIOURL.urlWithString( this.apiURL + "/entity/" + this.scheme + "/License/create-tokens-from-business/" + business.identifier + "/" + d );
    let urlRequest = new MWSJSONRequest();
    urlRequest.initWithURL(url, null, "GET");
    urlRequest.execute(this, function(code:number, json:any) { 
        completion(json["data"], json["error"]);
    });
}


// WebService.prototype.updateBusinessInstallment = function( business: BusinessLicense, date:Date, completion: any ) : void
// {
//     let d = (MUIWebApplication.sharedInstance().delegate as AppDelegate).serverDateFormatter.stringFromDate( date );

//     let body = {}
//     body["BusinessID"] = business.identifier;
//     body["Date"] = d;

//     const url = MIOURL.urlWithString(this.apiURL + "/entity/" + this.scheme + "/License/update-business-installment");
//     let urlRequest = new MWSJSONRequest();
//     urlRequest.initWithURL(url, body, "POST");
//     urlRequest.execute(this, function(code:number, json:any) { 
//         completion(json["data"], json["error"]);
//     });
// }

WebService.prototype.regenerateInvoice = function( invoiceNumber:string, business: BusinessLicense, tokenDate:Date, completion: any ) : void
{
    let body = {
        "BusinessID": business.identifier,
        "InvoiceNumber": invoiceNumber,
        "Date": ( MUIWebApplication.sharedInstance().delegate as AppDelegate ).serverDateFormatter.stringFromDate( tokenDate )
    }

    const url = this.toolURL + "/schema/" + this.scheme + "/License/re-generate-invoice";
    let r = new DLRequest( url, body, "POST" );
    r.execute(completion);
}

WebService.prototype.createReclaimInvoice = function( doc:Invoice, amount:number, completion:any ) {
    
    if (this.lock_doc_id.containsObject(doc.identifier)) return;
    this.lock_doc_id.addObject(doc.identifier);        

    const url_str = this.apiURL + "/entity/" + this.scheme + "/License/generate-reclaim-invoice"
    let r = new DLRequest ( url_str, { 
        "DocumentID": doc.identifier,
        "ReclaimAmount": amount 
    }, "POST" );
    
    r.execute( (json:any, error:string) => {
        this.lock_doc_id.removeObject(doc.identifier);

        if (error != null) {
            AppHelper.showErrorMessage( null, MIOLocalizeString("ERROR", "ERROR"), error );
        }
        else {
            let doc_number = json["DocumentNumber"];
            let msg = MIOLocalizeString("VOID_INVOICE_CREATED_SUCCESFULLY", "VOID INVOICE CREATED SUCCESFULLY");
            AppHelper.showInfoMessage( null, MIOLocalizeString("INFO", "INFO"), doc_number + " " + msg );
        }

        if (completion) completion(json, error);
    });
}

WebService.prototype.sendLicenseInvoice = function( doc:Invoice, completion:any ) {
    const url_str = this.toolURL + "/schema/" + this.scheme + "/License/send-email-invoice/" + doc.identifier;
    
    let r = new DLRequest ( url_str );    
    r.execute( (json:any, error:string) => {
        this.lock_doc_id.removeObject(doc.identifier);

        if (error != null) {
            AppHelper.showErrorMessage( null, MIOLocalizeString("ERROR", "ERROR"), error );
        }
        else {            
            let msg = MIOLocalizeString("INVOICE_SENT_SUCCESFULLY", "INVOICE SENT SUCCESFULLY");
            AppHelper.showInfoMessage( null, MIOLocalizeString("INFO", "INFO"), msg );
        }

        if (completion) completion(json, error);
    });
   
}
WebService.prototype.duplicateInstallment = function( installment:PaymentInstallment, date:Date, completion:any ) {
    const url_str = this.apiURL + "/entity/" + this.scheme + "/PaymentInstallment/duplicate-installment/" + installment.identifier;
    
    let body = { "Date": date };

    let r = new DLRequest ( url_str, body, "POST" );
    r.execute( (json:any, error:string) => {
        
        if (error != null) {
            AppHelper.showErrorMessage( null, MIOLocalizeString("ERROR", "ERROR"), error );
        }
        else {            
            let msg = MIOLocalizeString("INSTALLMENT_CREATED_SUCCESFULLY", "INSTALLMENT CREATED SUCCESFULLY");
            AppHelper.showInfoMessage( null, MIOLocalizeString("INFO", "INFO"), msg );
        }

        if (completion) completion(json, error);
    });
   
}

WebService.prototype.generateSEPAFileFromInstallments = function( installments:PaymentInstallment[], type:string, account:BankAccount, dueDate:string, filename:string, concept:string, completion:any ) {
    
    let cmd = new WebServiceCommand(this.integratorURL, "/accounting/schema/" + this.scheme + "/sepa/generate-from-installment-by-ids", true, null, filename);
    cmd.method = "POST";

    cmd.params = {
        "InstallmentIDs": installments.map ( (item:PaymentInstallment) => { return item.identifier; }),
        "DueDate": dueDate,
        "BankAccountID" : account.identifier,
        "SEPAType": type
    }

    if (filename != null) cmd.params["Filename"] = filename;
    if (concept != null) cmd.params["Concept"] = concept;

    cmd.execute(this, function (code:number, data:any) {
        //TODO: Show error
        if (code != 200 ) {
            AppHelper.showErrorMessage(null, "ERROR", "COULDN'T DOWNLOAD PDF. PLEASE CHECK IF YOU HAVE AN ACTIVE TEMPLATE");
        }
    });   
   
}

//
// Business ↔ venue link (BusinessLicense.authSchema). All four go through the HQ API
// server routes in DLAPIServer/ManagerRoutes/BusinessLicenseLink.swift, which own the
// auth side of each change; nothing here writes authSchema through the generic save.
//

interface WebService
{
    renameBusinessLicense( business: BusinessLicense, name:string, completion:DLCompletionCallback ) : void;
    createBusinessLicenseVenue( business: BusinessLicense, venue:any, completion:DLCompletionCallback ) : void;
    linkBusinessLicenseVenue( business: BusinessLicense, venueID:string, completion:DLCompletionCallback ) : void;
    fetchBusinessLicenseVenues( completion:DLCompletionCallback ) : void;
    startBusinessLicenseSeason( business: BusinessLicense, licenses:License[], date:Date, invoice:boolean, completion:DLCompletionCallback ) : void;
    endBusinessLicenseSeason( business: BusinessLicense, licenses:License[], date:Date, completion:DLCompletionCallback ) : void;
}

// The entity routes validate the login token against the schema, and create-venue
// forwards it to auth, which makes the admin the venue's first user.
function dlLinkRequest( url:string, body:any, method:string ) : DLRequest {
    let r = new DLRequest( url, body, method );
    let token = MIOUserDefaults.standardUserDefaults().valueForKey( "LoginToken" );
    if ( token != null ) r.setHeaderValue( token, "Authorization" );
    return r;
}

// Renames on both sides: auth first, then the licence. Nothing is changed locally by
// the call; the caller updates its object from the returned name.
WebService.prototype.renameBusinessLicense = function( business: BusinessLicense, name:string, completion:DLCompletionCallback ) : void
{
    const url = this.apiURL + "/entity/" + this.scheme + "/BusinessLicense/" + business.identifier + "/rename";
    dlLinkRequest( url, { "Name": name }, "POST" ).execute( completion );
}

// venue: { Name?, CountryISOCode, PostalCode?, LanguageISOCode, Timezone }. Creates the
// venue in auth for this licence and links it; data comes back with venueID.
WebService.prototype.createBusinessLicenseVenue = function( business: BusinessLicense, venue:any, completion:DLCompletionCallback ) : void
{
    const url = this.apiURL + "/entity/" + this.scheme + "/BusinessLicense/" + business.identifier + "/create-venue";
    dlLinkRequest( url, venue, "POST" ).execute( completion );
}

WebService.prototype.linkBusinessLicenseVenue = function( business: BusinessLicense, venueID:string, completion:DLCompletionCallback ) : void
{
    const url = this.apiURL + "/entity/" + this.scheme + "/BusinessLicense/" + business.identifier + "/link-venue";
    dlLinkRequest( url, { "VenueID": venueID }, "POST" ).execute( completion );
}

// Every venue auth knows: [{ id, name, status, environment, dbID, dbVersion, linkedLicenseID }].
WebService.prototype.fetchBusinessLicenseVenues = function( completion:DLCompletionCallback ) : void
{
    const url = this.apiURL + "/entity/" + this.scheme + "/BusinessLicense/venues";
    dlLinkRequest( url, null, "GET" ).execute( completion );
}

// Seasonal licences: the venue called to say it opened (start) or it closed (end).
// The server moves the season of the licences and saves; nothing is changed locally by the call.
// Without licences (null), the server acts on every seasonal licence of the business.
function dlSeasonRequest( url:string, licenses:License[], date:Date, body:any ) : DLRequest {
    body["Date"] = ( MUIWebApplication.sharedInstance().delegate as AppDelegate ).serverDateFormatter.stringFromDate( date );
    if ( licenses != null ) body["LicenseIDs"] = licenses.map( l => l.identifier );
    let r = dlLinkRequest( url, body, "POST" );
    let user = MIOUserDefaults.standardUserDefaults().valueForKey( "LastLoginEmail" );
    if ( user != null ) r.setHeaderValue( user, "DL-WORKER-NAME" );
    return r;
}

// The first period of the started licences is invoiced right away, in one invoice, unless
// invoice is false; data comes back with tokens and, when invoiced, documentNumber.
WebService.prototype.startBusinessLicenseSeason = function( business: BusinessLicense, licenses:License[], date:Date, invoice:boolean, completion:DLCompletionCallback ) : void
{
    const url = this.apiURL + "/entity/" + this.scheme + "/BusinessLicense/" + business.identifier + "/season-start";
    dlSeasonRequest( url, licenses, date, { "Invoice": invoice } ).execute( completion );
}

WebService.prototype.endBusinessLicenseSeason = function( business: BusinessLicense, licenses:License[], date:Date, completion:DLCompletionCallback ) : void
{
    const url = this.apiURL + "/entity/" + this.scheme + "/BusinessLicense/" + business.identifier + "/season-end";
    dlSeasonRequest( url, licenses, date, {} ).execute( completion );
}
